
export const Global = {
    isIndexedDbSupported: true
}